import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  root: {
    height: '400px',
    ' & > div': {
      position: 'relative !important'
    }
  }

}))
